import { EventEmitter, Injectable } from '@angular/core';
import { FhMenuModel } from '../objects/fh-menu-model';

@Injectable({
  providedIn: 'root'
})
export class FhMenuProviderService {
  menuToggleExpanded: EventEmitter<boolean> = new EventEmitter<boolean>();
  dropdownToggleChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  stateMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  activeToggleChanged: EventEmitter<FhMenuModel> = new EventEmitter<FhMenuModel>();
  itemClicked: EventEmitter<FhMenuModel> = new EventEmitter<FhMenuModel>();

  isMenuExpanded = true;
}
